import { render, staticRenderFns } from "./TabObjectDetails.vue?vue&type=template&id=4dc1ef60&scoped=true"
import script from "./TabObjectDetails.vue?vue&type=script&lang=js"
export * from "./TabObjectDetails.vue?vue&type=script&lang=js"
import style0 from "./TabObjectDetails.vue?vue&type=style&index=0&id=4dc1ef60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1ef60",
  null
  
)

export default component.exports